
      // -------------------------------------------//
     //              Directive Favorite
    // -------------------------------------------//
    // Little Star close to a datapoint

      angular.module('app.directives.playbutton',[]).
      directive('playbutton',
    [
        '$q',

    function($q) {
    var obj = {
          scope:
            {
                kCallback:'=kCallback',
                kCallbackParams : '=kCallbackParams',
                model : '=model',
                // Suppress Apply on Write model
                supressApply : '=supressApply'
            },
           restrict:'AE',
           templateUrl: 'views/form/playbutton.html',
           link: function(scope,element, attrs, controller)
              {


      // -------------------------------------------//
     //             Init Favorite
    // -------------------------------------------//
                scope.$watch('model',function(){
                    scope.value = scope.model;
                })
               scope.play = function()
               {
                   scope.value = true;
                   scope.writeToModel();



               }
                  scope.writeToModel = function (){
                      if(typeof scope.kCallback == 'function')
                      {
                          var defer = $q.defer();
                          var back = scope.kCallback({promise:defer,params : scope.kCallbackParams,value:scope.value, withButtons : scope.withButtons,playButton:true});
                          // Write to Model if return value == true;
                          defer.promise.then(function(){
                              // scope.model = scope.value;
                              scope.interact = false;
                              // We need to render by new model, because scope.model $watch does not fire in fact of scope.interact is true
                              // This is important if we change by Slider and datapoint directive shows buttons for save and clear
                              // While Buttons were shown no new data (e.g. interval) were parsed.
                              scope.value = scope.model;
                            //  renderSliderByValue(scope.model);

                          },function(){

                          })
                      }else{
                          // Nothing to check;
                          scope.model = scope.value;
                          scope.interact = false;
                          // Careful using this.
                          // Without a callback (Scenes SetDatapoint) we can run into performance issues
                          // But we need this because Parent Object needs dirtyCheck cycle to display current value
                          // Todo: In future use pherhaps implement a scope.supressApply to handle this
                          if(scope.supressApply){ return };
                          scope.$apply();
                      }

                  }

               scope.stop = function()
               {
                   scope.value = false;
                   scope.writeToModel();


               }



              }
        };
        return obj ;
   }]);
